import { createRoot } from "react-dom/client"
import App from "./components/App"

const container = document.getElementById("root")
if (container) {
  createRoot(container).render(<App />)
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker", { scope: "/" })
  })
}
